import React from 'react'
import PropTypes from 'prop-types'
import {
  Select,
  MenuItem,
} from '@material-ui/core'

class ComparatorSelect extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: null,
  }

  comparator = {
    eq: 'Equal',
    neq: 'Not equal',
    gt: 'Greater than',
    lt: 'Less than',
  }

  onChange = (e) => {
    this.props.onChange(e.target.value)
  }

  render() {
    const { value, onChange, ...props } = this.props
    return (
      <Select value={value} onChange={this.onChange} {...props}>
        {Object.entries(this.comparator).map(([k, v]) => (
          <MenuItem key={k} value={k}>
            {v}
          </MenuItem>
        ))}
      </Select>
    )
  }
}

export default ComparatorSelect
